import { render, staticRenderFns } from "./FormRating.vue?vue&type=template&id=453f6023&scoped=true&"
import script from "./FormRating.vue?vue&type=script&lang=js&"
export * from "./FormRating.vue?vue&type=script&lang=js&"
import style0 from "./FormRating.vue?vue&type=style&index=0&id=453f6023&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453f6023",
  null
  
)

export default component.exports